import React from "react";
import {
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Checkbox,
  ListItemText,
  FormHelperText,
} from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import { useTranslation } from "react-i18next";

const useStyles = makeStyles((theme) => ({}));
function SearchSecondaryInfo(props) {
  const classes = useStyles();
  const { t } = useTranslation();
  return (
    <FormControl className={classes.formControl}>
      <InputLabel htmlFor="search-secondary-info">
        {t("search_secondary_info")}
      </InputLabel>
      <Select
        value={props.secondaryInfo}
        onChange={(e) => props.onChange(e.target.value)}
        renderValue={(selected) => selected.map((s) => t(s)).join(", ")}
        inputProps={{
          name: "searchSecondary",
          id: "search-secondary-info",
        }}
        multiple
      >
        <MenuItem
          key={"global_category_plural"}
          value={"global_category_plural"}
          disabled={
            props.secondaryInfo.length >= 2 &&
            props.secondaryInfo.indexOf("global_category_plural") === -1
          }
        >
          <Checkbox
            disabled={
              props.secondaryInfo.length >= 2 &&
              props.secondaryInfo.indexOf("global_category_plural") === -1
            }
            checked={props.secondaryInfo.indexOf("global_category_plural") > -1}
          />
          <ListItemText primary={t("global_category_plural")} />
        </MenuItem>
        <MenuItem
          key={"live_draft_status"}
          value={"live_draft_status"}
          disabled={
            props.secondaryInfo.length >= 2 &&
            props.secondaryInfo.indexOf("live_draft_status") === -1
          }
        >
          <Checkbox
            disabled={
              props.secondaryInfo.length >= 2 &&
              props.secondaryInfo.indexOf("live_draft_status") === -1
            }
            checked={props.secondaryInfo.indexOf("live_draft_status") > -1}
          />
          <ListItemText primary={t("live_draft_status")} />
        </MenuItem>
        <MenuItem
          value={"global_author"}
          disabled={
            props.secondaryInfo.length >= 2 &&
            props.secondaryInfo.indexOf("global_author") === -1
          }
        >
          <Checkbox
            disabled={
              props.secondaryInfo.length >= 2 &&
              props.secondaryInfo.indexOf("global_author") === -1
            }
            checked={props.secondaryInfo.indexOf("global_author") > -1}
          />
          <ListItemText primary={t("global_author")} />
        </MenuItem>
        <MenuItem
          value={"global_like_plural"}
          disabled={
            props.secondaryInfo.length >= 2 &&
            props.secondaryInfo.indexOf("global_like_plural") === -1
          }
        >
          <Checkbox
            disabled={
              props.secondaryInfo.length >= 2 &&
              props.secondaryInfo.indexOf("global_like_plural") === -1
            }
            checked={props.secondaryInfo.indexOf("global_like_plural") > -1}
          />
          <ListItemText primary={t("global_like_plural")} />
        </MenuItem>
        <MenuItem
          value={"global_view_plural"}
          disabled={
            props.secondaryInfo.length >= 2 &&
            props.secondaryInfo.indexOf("global_view_plural") === -1
          }
        >
          <Checkbox
            disabled={
              props.secondaryInfo.length >= 2 &&
              props.secondaryInfo.indexOf("global_view_plural") === -1
            }
            checked={props.secondaryInfo.indexOf("global_view_plural") > -1}
          />
          <ListItemText primary={t("global_view_plural")} />
        </MenuItem>
        <MenuItem
          value={"global_topic"}
          disabled={
            props.secondaryInfo.length >= 2 &&
            props.secondaryInfo.indexOf("global_topic") === -1
          }
        >
          <Checkbox
            disabled={
              props.secondaryInfo.length >= 2 &&
              props.secondaryInfo.indexOf("global_topic") === -1
            }
            checked={props.secondaryInfo.indexOf("global_topic") > -1}
          />
          <ListItemText primary={t("global_topic")} />
        </MenuItem>
        <MenuItem
          value={"search_info_date_created"}
          disabled={
            props.secondaryInfo.length >= 2 &&
            props.secondaryInfo.indexOf("search_info_date_created") === -1
          }
        >
          <Checkbox
            disabled={
              props.secondaryInfo.length >= 2 &&
              props.secondaryInfo.indexOf("search_info_date_created") === -1
            }
            checked={
              props.secondaryInfo.indexOf("search_info_date_created") > -1
            }
          />
          <ListItemText primary={t("search_info_date_created")} />
        </MenuItem>
        <MenuItem
          value={"search_info_date_modified"}
          disabled={
            props.secondaryInfo.length >= 2 &&
            props.secondaryInfo.indexOf("search_info_date_modified") === -1
          }
        >
          <Checkbox
            disabled={
              props.secondaryInfo.length >= 2 &&
              props.secondaryInfo.indexOf("search_info_date_modified") === -1
            }
            checked={
              props.secondaryInfo.indexOf("search_info_date_modified") > -1
            }
          />
          <ListItemText primary={t("search_info_date_modified")} />
        </MenuItem>
        <MenuItem
          value={"document_type"}
          disabled={
            props.secondaryInfo.length >= 2 &&
            props.secondaryInfo.indexOf("document_type") === -1
          }
        >
          <Checkbox
            disabled={
              props.secondaryInfo.length >= 2 &&
              props.secondaryInfo.indexOf("document_type") === -1
            }
            checked={props.secondaryInfo.indexOf("document_type") > -1}
          />
          <ListItemText primary={t("document_type")} />
        </MenuItem>
        <MenuItem
          value={"document_url"}
          disabled={
            props.secondaryInfo.length >= 2 &&
            props.secondaryInfo.indexOf("document_url") === -1
          }
        >
          <Checkbox
            disabled={
              props.secondaryInfo.length >= 2 &&
              props.secondaryInfo.indexOf("document_url") === -1
            }
            checked={props.secondaryInfo.indexOf("document_url") > -1}
          />
          <ListItemText primary={t("document_url")} />
        </MenuItem>
        <MenuItem
          value={"global_knowledge_source"}
          disabled={
            props.secondaryInfo.length >= 2 &&
            props.secondaryInfo.indexOf("global_knowledge_source") === -1
          }
        >
          <Checkbox
            disabled={
              props.secondaryInfo.length >= 2 &&
              props.secondaryInfo.indexOf("global_knowledge_source") === -1
            }
            checked={
              props.secondaryInfo.indexOf("global_knowledge_source") > -1
            }
          />
          <ListItemText primary={t("global_knowledge_source")} />
        </MenuItem>
      </Select>
      <FormHelperText>{t("search_secondary_info_helper_text")}</FormHelperText>
    </FormControl>
  );
}

export default SearchSecondaryInfo;
